import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material';
import { colors, fonts } from 'components/styles/variables';
import chevron from 'public/static/images/srp/Chevron.svg';
import { theme } from 'components/Shared/ThemeProviderWrapper';

export interface ModalDropdownContainerStylesProps {
  fullHeight?: boolean;
}

export const useStyles = makeStyles<Theme, ModalDropdownContainerStylesProps>({
  dropdown: {
    minWidth: '248px',
    alignItems: 'center',
    paddingLeft: '16px',
    display: 'flex',
    flexDirection: 'row',
    gap: '8px',
    backgroundColor: colors.WHITE,
    height: '44px',
    borderRadius: '4px',
    margin: '0 16px 16px 16px',
    border: `1px solid ${colors.G2}`,
    cursor: 'pointer',
    fontFamily: fonts.default,
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '20px',
    letterSpacing: '0.2px',
    color: colors.BLACK,

    '&:hover': {
      borderColor: colors.BLACK,
    },
  },

  dropdownDisabled: {
    color: colors.G3,

    '&:hover': {
      borderColor: colors.G2,
    },
  },

  dropdownTitle: {
    width: '100%',
    height: '44px',
    padding: '12px 0',
    lineHeight: '22px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },

  chevron: {
    display: 'flex',
    backgroundImage: `url(${chevron})`,
    width: '14px',
    height: '9px',
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    paddingRight: '24px',
  },

  modalDropdown: {
    cursor: 'pointer',
    outline: 'inherit',
    textAlign: 'inherit',
  },

  dialog: (props) => ({
    maxHeight: '465px',
    minWidth: '298px',
    overflowY: 'hidden',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      height: props.fullHeight ? '100%' : undefined,
    },
  }),
});
